import projectTasksApi from '@/api/projectTasks';
import regularTasksApi from '@/api/regularTasks';
import { debug } from 'util';

const state = {
  projectTasks: [],
  allProjectTasks: [],
  projectTask: {
    totalMin:0,
    totalMax:0,
    totalQaMax: 0,
    subTotalHourMin: 0
  },
};

export const getters = {
  getTask: state => {
    return state.projectTask;
  }
}

export const actions = {
  getList({ commit }, arg) {
    projectTasksApi.getProjectTasks(arg).then((data) => {
      commit('projectTasks', data.projectTasks);
    });
  },

  getAll({ commit }) {
    projectTasksApi.getAllProjectTasks().then((data) => {
      commit('allProjectTasks', data.projectTasks);
    });
  },

  get({ commit }, arg) {
    projectTasksApi.getProjectTask(arg).then((data) => {
      commit('projectTask', data.projectTask);
    });
  },

  save({ commit, dispatch, state , getters}, args) {
    commit
    dispatch('setCalcul', args.task.multiplicator);
    commit('projectTask', state.projectTask);

    //commit('projectTask', args.task);
    //dispatch('setCalcul', args.task.multiplicator);
    // projectTasksApi.saveProjectTask(args.task).then((data) => {
    //   regularTasksApi.getListByRequirement(state.projectTask.taskGuid).then((data) => {
    //     var test2 = state.projectTask;
    //     test2.multiplicator = data.regularTasks;
    //     dispatch('setCalcul', data.regularTasks)
    //     commit('projectTask', test2)
    //     projectTasksApi.editProjectTask(test2);
    //   });
    // });
    projectTasksApi.saveProjectTask(state.projectTask).then((data) => {
      projectTasksApi.getProjectTasks(args.task.projectGuid).then((data) => {
        commit('projectTasks', data.projectTasks);
        this.projectTasks;
      });
    });
  },

  editAndSave({ commit, dispatch, state , getters}, args) {

    //commit('projectTask', args.task);
    //dispatch('setCalcul', args.task.multiplicator);

    var test = JSON.parse( JSON.stringify( args ));

    test.task.multiplicator = [];
    test.task.newTasks = [];
     Array.prototype.forEach.call(args.task.newTasks, element =>{
      test.task.multiplicator.push(element);          
    });
    projectTasksApi.editProjectTask(args.task).then((data) => {
    projectTasksApi.saveProjectTask(test.task).then((data) => {
      regularTasksApi.getListByRequirement(state.projectTask.taskGuid).then((data) => {
        test.task.multiplicator = data.regularTasks;

        //Array.prototype.forEach.call(args.task.newTasks, element =>{
        //  element.
        //  test.task.multiplicator.push(element);          
        //});

        dispatch('setCalcul', test.task.multiplicator);
        commit('projectTask', state.projectTask);
        test.task = state.projectTask;
        test.task.multiplicator = data.regularTasks;
        projectTasksApi.editProjectTask(test.task).then((data) => {
          projectTasksApi.getProjectTasks(args.task.projectGuid).then((data) => {
            commit('projectTasks', data.projectTasks);
            this.projectTasks;
          });
        });

      });
    });
  });

  },

  edit({ commit, dispatch, state }, args) {
    //dispatch('setCalcul', args.task.multiplicator);`
    commit('projectTask', args.task);
    state.projectTask;
    projectTasksApi.editProjectTask(args.task).then((data) => {
      regularTasksApi.getListByRequirement(state.projectTask.taskGuid).then((data) => {
        var test2 = state.projectTask;
        test2.multiplicator = data.regularTasks;
        dispatch('setCalcul', data.regularTasks)
        commit('projectTask', test2)
        projectTasksApi.editProjectTask(test2).then((data) => {
          commit('projectTasks', data.projectTasks);
        projectTasksApi.getProjectTasks(args.task.projectGuid).then((data) => {
        commit('projectTasks', data.projectTasks);
        this.projectTasks;
      });
        });

    });
    });

  
    commit(
      'alert/add',
      {
        title: 'Informations',
        message: 'Le tâche a été modifiée avec succès!',
        variant: 'success',
        icon: 'check_circle',
      },
      { root: true },
    );
  },


  search({ commit }, arg) {
    projectTasksApi.searchProjectTask(arg).then((data) => {
      commit('projectTasks', data.projectTasks);
    });
  },

  setCalculNewTask({dispatch}, arg){
    regularTasksApi.getListByRequirement(arg).then((data) => {
      dispatch('setCalcul',data);
      commit('projectTasks', data.projectTasks);
  });
},
  setCalcul({ dispatch }, arg) {

    dispatch('calculSubTotalHourMin', arg);
    dispatch('calculSubTotalHourMax', arg);
    dispatch('calculTotalProgMin');
    dispatch('calculTotalProgMax');
    dispatch('calculTotalGestionTechMin');
    dispatch('calculTotalGestionTechMax');
    dispatch('calculTotalAnalysisMin');
    dispatch('calculTotalAnalysisMax');
    dispatch('calculTotalQaMin');
    dispatch('calculTotalQaMax');
    dispatch('calculTotalMin');
    dispatch('calculTotalMax');
  },

  calculSubTotalHourMin({ commit }, arg) {
    let subTotalHourMin = null;
    for (let i = 0; i < arg.length; i += 1) {
      if (arg[i].multiplicator > 0 || arg[i].multiplicator != null) {
        subTotalHourMin += arg[i].timeMin * arg[i].multiplicator;
      }
    }
    commit('subTotalHourMin', Math.ceil(subTotalHourMin));
  },

  calculSubTotalHourMax({ commit }, arg) {
    let subTotalHourMax = null;
    for (let i = 0; i < arg.length; i += 1) {
      if (arg[i].multiplicator > 0 || arg[i].multiplicator != null) {
        subTotalHourMax += arg[i].timeMax * arg[i].multiplicator;
      }
    }
    commit('subTotalHourMax', Math.ceil(subTotalHourMax));
  },

  calculTotalProgMin({ state, commit, rootState }) {

    let UnitTestProjectIndex = this.getters['parameters/getIndex']('UnitTestProject');
    let ErrorMarginProjectIndex = this.getters['parameters/getIndex']('ErrorMarginProject');
    const one =
      state.projectTask.subTotalHourMin * (UnitTestProjectIndex.defaultValue / 100);
    const two =
      state.projectTask.subTotalHourMin *
      (ErrorMarginProjectIndex.defaultValue / 100);
    const totalProgMin = state.projectTask.subTotalHourMin + one + two;
    commit('totalProgMin', Math.ceil(totalProgMin));
  },

  calculTotalProgMax({ state, commit, rootState }) {
    let UnitTestProjectIndex = this.getters['parameters/getIndex']('UnitTestProject');
    let ErrorMarginProjectIndex = this.getters['parameters/getIndex']('ErrorMarginProject');
    const one =
      state.projectTask.subTotalHourMax * (UnitTestProjectIndex.defaultValue / 100);
    const two =
      state.projectTask.subTotalHourMax *
      (ErrorMarginProjectIndex.defaultValue / 100);
    const totalProgMax = state.projectTask.subTotalHourMax + one + two;
    commit('totalProgMax', Math.ceil(totalProgMax));
  },

  calculTotalAnalysisMin({ state, commit, rootState }) {
    let ArchitectureProjectIndex = this.getters['parameters/getIndex']('ArchitectureProject');
    let AnalysisProjectIndex = this.getters['parameters/getIndex']('AnalysisProject');
    const one =
      state.projectTask.subTotalHourMin *
      (AnalysisProjectIndex.defaultValue / 100);
    const two =
      state.projectTask.subTotalHourMin * (ArchitectureProjectIndex.defaultValue / 100);
    const totalAnalysisMin = one + two;
    commit('totalAnalysisMin', Math.ceil(totalAnalysisMin));
  },

  calculTotalAnalysisMax({ state, commit, rootState }) {
    let ArchitectureProjectIndex = this.getters['parameters/getIndex']('ArchitectureProject');
    let AnalysisProjectIndex = this.getters['parameters/getIndex']('AnalysisProject');

    const one =
      state.projectTask.subTotalHourMax *
      (AnalysisProjectIndex.defaultValue / 100);
    const two =
      state.projectTask.subTotalHourMax * (ArchitectureProjectIndex.defaultValue / 100);
    const totalAnalysisMax = one + two;
    commit('totalAnalysisMax', Math.ceil(totalAnalysisMax));
  },

  calculTotalQaMin({ state, commit, rootState }) {
    let QualityInsuranceProjectIndex = this.getters['parameters/getIndex']('QualityInsuranceProject');

    const totalQaMin =
      state.projectTask.subTotalHourMin *
      (QualityInsuranceProjectIndex.defaultValue / 100);
    commit('totalQaMin', Math.ceil(totalQaMin));
  },

  calculTotalQaMax({ state, commit, rootState }) {
    let QualityInsuranceProjectIndex = this.getters['parameters/getIndex']('QualityInsuranceProject');
    const totalQaMax =
      state.projectTask.subTotalHourMax *
      (QualityInsuranceProjectIndex.defaultValue / 100);

    commit('totalQaMax', Math.ceil(totalQaMax));
  },
  calculTotalGestionTechMin({ state, commit, rootState }) {
    let GestionTechIndex = this.getters['parameters/getIndex']('GestionTech');
    const totalGestionTechMin =

      state.projectTask.totalProgMin *
      (GestionTechIndex.defaultValue / 100);

    commit('totalGestionTechMin', Math.ceil(totalGestionTechMin));
  },

  calculTotalGestionTechMax({ state, commit, rootState }) {
    let GestionTechIndex = this.getters['parameters/getIndex']('GestionTech');
    const totalGestionTechMax =

      state.projectTask.totalProgMax *
      (GestionTechIndex.defaultValue / 100);

    commit('totalGestionTechMax', Math.ceil(totalGestionTechMax));
  },
  calculTotalMin({ state, commit }) {
    const totalMin =
      state.projectTask.totalProgMin +
      state.projectTask.totalAnalysisMin +
      state.projectTask.totalGestionTechMin +
      state.projectTask.totalQaMin;
    commit('totalMin', Math.ceil(totalMin));
  },

  calculTotalMax({ state, commit }) {
    const totalMax =
      state.projectTask.totalProgMax +
      state.projectTask.totalAnalysisMax +
      state.projectTask.totalGestionTechMax +
      state.projectTask.totalQaMax;
    commit('totalMax', Math.ceil(totalMax));
  },
  delete({ dispatch }, args) {
    projectTasksApi.deleteProjectTask(args.taskGuid).then(() => {
      dispatch('getList', args.projectGuid);
    });
  },
};
export const mutations = {
  projectTasks(state, payload) {
    state.projectTasks = payload;
  },

  allProjectTasks(state, payload) {
    state.allProjectTasks = payload;
  },
  projectTask(state, payload) {

    if(payload.totalMin || payload.totalMin == 0)
    {
      state.projectTask = payload;
    }
    
  },

  subTotalHourMin(state, payload) {
    state.projectTask.subTotalHourMin = payload;
  },
  subTotalHourMax(state, payload) {
    state.projectTask.subTotalHourMax = payload;
  },

  totalProgMin(state, payload) {
    state.projectTask.totalProgMin = payload;
  },
  totalProgMax(state, payload) {
    state.projectTask.totalProgMax = payload;
  },

  totalAnalysisMin(state, payload) {
    state.projectTask.totalAnalysisMin = payload;
  },

  totalAnalysisMax(state, payload) {
    state.projectTask.totalAnalysisMax = payload;
  },
  totalQaMin(state, payload) {
    state.projectTask.totalQaMin = payload;
  },
  totalGestionTechMin(state, payload) {
    state.projectTask.totalGestionTechMin = payload;
  },
  totalGestionTechMax(state, payload) {
    state.projectTask.totalGestionTechMax = payload;
  },
  totalQaMax(state, payload) {
    state.projectTask.totalQaMax = payload;
  },

  totalMin(state, payload) {
    state.projectTask.totalMin = payload;
  },
  totalMax(state, payload) {
    state.projectTask.totalMax = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
